/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-07T17:13:04+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AButton from 'common/buttons/components/AButton';

/**
 * MActionsCalendar - …
 */
class MActionsCalendar extends Component {
  /**
     * react render() <MActionsCalendar>
     *
     * @return {object}
     */
  render() {
    const {
      autoOk,
      labelCancel,
      labelOk,
      disableCancel,
      disableOk,
      onPressCancel,
      onPressOk,
    } = this.props;

    return (
      <div className="m-actions m-actions-calendar">
        <AButton
          disabled={disableCancel}
          label={labelCancel}
          onPress={onPressCancel}
          size={'small'}
          look={'filled'} />

        {!autoOk &&
                    <AButton
                      disabled={disableOk}
                      label={labelOk}
                      onPress={onPressOk}
                      size={'small'}
                      look={'filled'}
                    />
        }
      </div>
    );
  }
}


MActionsCalendar.propTypes = {
  autoOk: PropTypes.bool,
  labelCancel: PropTypes.node,
  labelOk: PropTypes.node,
  disableCancel: PropTypes.bool,
  disableOk: PropTypes.bool,
  onPressCancel: PropTypes.func,
  onPressOk: PropTypes.func,
};
MActionsCalendar.defaultProps = {
  labelOk: 'OK',
  labelCancel: 'Cancel',
};
export default MActionsCalendar;

